 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		3: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		3: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"cd87ee334d81bd5adc6ecabb633996e30870a7b1","1":"styles","5":"component---src-pages-404-js","6":"component---src-pages-about-us-our-philosophy-js","7":"component---src-pages-about-us-who-we-are-js","8":"component---src-pages-about-us-why-choose-us-js","9":"component---src-pages-clients-business-owner-js","10":"component---src-pages-clients-professional-salaried-employee-js","11":"component---src-pages-clients-retirees-js","12":"component---src-pages-clients-woman-js","13":"component---src-pages-contact-us-js","14":"component---src-pages-disclaimer-js","15":"component---src-pages-index-js","16":"component---src-pages-resources-blog-js","17":"component---src-pages-resources-blog-selecting-a-fund-manager-js","18":"component---src-pages-resources-book-summaries-fooled-by-randomness-nassim-nicholas-taleb-js","19":"component---src-pages-resources-book-summaries-influence-the-psychology-of-persuasion-by-robert-b-cialdini-js","20":"component---src-pages-resources-book-summaries-js","21":"component---src-pages-resources-book-summaries-one-up-on-wall-street-js","22":"component---src-pages-resources-book-summaries-the-little-book-that-builds-wealth-pat-dorsey-js","23":"component---src-pages-resources-book-summaries-the-most-important-thing-howard-marks-js","24":"component---src-pages-resources-media-js","25":"component---src-pages-resources-tools-5-minute-health-check-js","26":"component---src-pages-resources-tools-investment-advisory-js","27":"component---src-pages-resources-tools-js","28":"component---src-pages-resources-tools-risk-profile-js","29":"component---src-pages-resources-tools-thankyou-js","30":"component---src-pages-services-client-engagement-js","31":"component---src-pages-services-client-journey-js","32":"component---src-pages-services-fee-philosophy-js","33":"component---src-pages-services-offerings-comprehensive-wealth-management-js","34":"component---src-pages-services-offerings-direct-equities-advisory-js","35":"component---src-pages-services-offerings-js","36":"component---src-pages-services-offerings-mutual-funds-advisory-js","37":"component---src-pages-services-offerings-second-look-js","38":"component---src-pages-statutory-js","39":"component---src-pages-statutory-pms-js","40":"component---src-pages-statutory-ria-js"}[chunkId]||chunkId) + "-" + {"0":"f4d4177fdf131f4d2433","1":"e9d24b1846c7d6eb9685","5":"106c4f469b83812cbc17","6":"afc8c1ffb24f4ff283cc","7":"462b176288394c3d8f53","8":"4e69612f04743bd690c4","9":"d1b1c9af9e0c6f778aea","10":"7f4aeb22f32f1ce2bfce","11":"991fcbeb5bd94ce504fb","12":"a13a2318f0c38d38c399","13":"8bb47ce133cad7928981","14":"84d3d83777426bd8a0f1","15":"436ebd8239c4a75e8fa2","16":"05a57c206ff2a678c3ac","17":"7477df8fdaa17d09c642","18":"792d77cc13b615dbd916","19":"e99d136c01c2917b0e59","20":"42033bd410fe567bd735","21":"4487f17214c4208ab9d2","22":"a8660604a5dd05d39874","23":"9e76c974de6adf0ec80c","24":"0f624da8bfc843a2fd0c","25":"56f256ec6ac4045d6eca","26":"155cdbefaecd4faf791f","27":"88f0afc1596e562b5f27","28":"0dc5f5d51e51c0c7f7fa","29":"9c8a9269f8087979a40b","30":"7100d829df22053e26bd","31":"71ccba9836a2caa60a05","32":"4b129dd84247a37e26a6","33":"acfd09421aaba0fa6c4d","34":"f29a79126a5225c85397","35":"62bb1dc015927d813315","36":"4c828546baf48b46acfc","37":"be6f8ce723ba1f6077f5","38":"f071c353d23670664259","39":"84bdb1ac6f3b3343d360","40":"99d3fd841ee520e74496"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"cd87ee334d81bd5adc6ecabb633996e30870a7b1","1":"styles","5":"component---src-pages-404-js","6":"component---src-pages-about-us-our-philosophy-js","7":"component---src-pages-about-us-who-we-are-js","8":"component---src-pages-about-us-why-choose-us-js","9":"component---src-pages-clients-business-owner-js","10":"component---src-pages-clients-professional-salaried-employee-js","11":"component---src-pages-clients-retirees-js","12":"component---src-pages-clients-woman-js","13":"component---src-pages-contact-us-js","14":"component---src-pages-disclaimer-js","15":"component---src-pages-index-js","16":"component---src-pages-resources-blog-js","17":"component---src-pages-resources-blog-selecting-a-fund-manager-js","18":"component---src-pages-resources-book-summaries-fooled-by-randomness-nassim-nicholas-taleb-js","19":"component---src-pages-resources-book-summaries-influence-the-psychology-of-persuasion-by-robert-b-cialdini-js","20":"component---src-pages-resources-book-summaries-js","21":"component---src-pages-resources-book-summaries-one-up-on-wall-street-js","22":"component---src-pages-resources-book-summaries-the-little-book-that-builds-wealth-pat-dorsey-js","23":"component---src-pages-resources-book-summaries-the-most-important-thing-howard-marks-js","24":"component---src-pages-resources-media-js","25":"component---src-pages-resources-tools-5-minute-health-check-js","26":"component---src-pages-resources-tools-investment-advisory-js","27":"component---src-pages-resources-tools-js","28":"component---src-pages-resources-tools-risk-profile-js","29":"component---src-pages-resources-tools-thankyou-js","30":"component---src-pages-services-client-engagement-js","31":"component---src-pages-services-client-journey-js","32":"component---src-pages-services-fee-philosophy-js","33":"component---src-pages-services-offerings-comprehensive-wealth-management-js","34":"component---src-pages-services-offerings-direct-equities-advisory-js","35":"component---src-pages-services-offerings-js","36":"component---src-pages-services-offerings-mutual-funds-advisory-js","37":"component---src-pages-services-offerings-second-look-js","38":"component---src-pages-statutory-js","39":"component---src-pages-statutory-pms-js","40":"component---src-pages-statutory-ria-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"b4c7bfc4bff091a88624","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
